/**
 * 专利镖局 退款管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>退款管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
          <el-input size="small" v-model="formInline.mobile" style="width:120px" placeholder="输入联系方式"></el-input>
          <el-input size="small" v-model="formInline.order_sn" style="width:120px" placeholder="输入原订单号"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select size="small" v-model="formInline.status" style="width:140px" placeholder="请选择">
          <el-option v-for="type in status" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item>
        <el-select size="small" v-model="formInline.zfsj" style="width:140px" placeholder="请选择">
          <el-option v-for="type in zfsj" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择申请开始时间"> </el-date-picker>
         <!-- <el-date-picker v-model="formInline.start_time" align="right" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker> -->
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择申请结束时间"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="order_sn" align="center" label="原订单号" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mobile" align="center" label="联系方式" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="total_fee" align="center" label="原订单金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="refund_fee" align="center" label="退款金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="refund_reason" align="center" label="退款理由" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status" align="center" label="状态" :formatter="statusFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="audit_opinion" align="center" label="审核意见" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="申请时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="upd_time" align="center" label="审核时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
          <el-button size="mini" type="primary" @click="handleCheck(scope.$index, scope.row)">审核</el-button>
          <el-button size="mini" type="danger" @click="delMonitor(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm">
            <el-form-item label="原订单号">
              <el-input size="small" v-model="infoForm.order_sn" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input size="small" v-model="infoForm.mobile" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="原订单金额">
            <el-input size="small" v-model="infoForm.total_fee" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="退款金额">
            <el-input size="small" v-model="infoForm.refund_fee" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="退款理由">
            <el-input size="small" v-model="infoForm.refund_reason" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="审核意见">
              <el-input size="small" v-model="infoForm.audit_opinion" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-input size="small" v-model="infoForm.status" :formatter="statusFormat" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请时间">
            <el-input size="small" v-model="infoForm.add_time" auto-complete="off" disabled></el-input>
            </el-form-item>       
            <el-form-item label="审核时间">
            <el-input size="small" v-model="infoForm.upd_time" auto-complete="off" disabled></el-input>
            </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 审核界面 -->
    <el-dialog :title="title" :visible.sync="checkFormVisible" width="50%" @click="closeDialog('checkForm')">
      <el-form label-width="120px" :model="checkForm" ref="checkForm" :rules="checkFormRules">
            <el-form-item label="原订单号">
              <el-input size="small" v-model="checkForm.order_sn" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input size="small" v-model="checkForm.mobile" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="原订单金额">
            <el-input size="small" v-model="checkForm.total_fee" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="退款金额">
            <el-input size="small" v-model="checkForm.refund_fee" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="退款理由">
            <el-input size="small" v-model="checkForm.refund_reason" auto-complete="off" disabled></el-input>
            </el-form-item>
        
            <!-- <el-form-item label="状态">
              <el-input size="small" v-model="checkForm.status" :formatter="statusFormat" auto-complete="off" disabled></el-input>
            </el-form-item> -->

            <el-form-item label="退款审核" prop="status">
                <el-radio-group type="kind" v-model="checkForm.status">  
                    <!-- <el-radio v-model="checkForm.status" :label="1" style="font-size: 25px" >待审核</el-radio> -->
                    <el-radio v-model="checkForm.status" :label="2">通过</el-radio>
                    <el-radio v-model="checkForm.status" :label="3">不通过</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="审核意见" prop="audit_opinion">
              <el-input size="small" v-model="checkForm.audit_opinion" auto-complete="off" placeholder="请填写审核意见"></el-input>
            </el-form-item>

            <el-form-item label="申请时间">
            <el-input size="small" v-model="checkForm.add_time" auto-complete="off" disabled></el-input>
            </el-form-item>       
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitForm('checkForm')">提交</el-button>
              <el-button size="mini" @click='closeDialog("checkForm")'>取消</el-button>
            </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { wechatRefund, wechatUrl, wechatCheckRefund } from '../../api/wechatMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      checkFormVisible: false, //控制审核页面显示与隐藏
      title: '监控详情',
      multipleSelection: [],
      status: [
        { key: '全部', value: 0 },
        { key: '待审核', value: 1 },
        { key: '退款成功', value: 2 },
        { key: '退款失败', value: 3 }
      ],
      infoForm: {
        id: '',
        mobile: '',
        audit_opinion: '',
        order_sn: '',
        refund_fee: '',
        refund_reason: '',
        status: '',
        total_fee: '',
        upd_time: '',
        add_time: ''
      },
       formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        mobile: '',
        order_sn: '',
        status: 0,
        origin: 2
      },
      checkForm: {
        id: '',
        total_fee: '',
        audit_opinion: '',
        status: '',
        refund_fee: '',
        refund_reason: '',
        mobile: '',
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       // 表单验证
      checkFormRules: {
        audit_opinion: [
          { required: true, message: '请填写审核意见', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择审核状态', trigger: 'blur' }
        ]
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      wechatRefund(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //导出excel
    exportCheck() {
      //判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定导出勾选的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        
        const idStr = JSON.stringify(idsArr)
        console.log(idStr)
        // console.log(data)
        window.location.href = wechatUrl + "/admin/patent/exportOrderPdfExcel?ids=" + idStr
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    exportAll() {
      this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
       .then(() => {
          window.location.href = wechatUrl + "/admin/patent/exportOrderPdfAllExcel?zlmc="+this.formInline.zlmc+"&mobile="+this.formInline.mobile+"&zlbh="+this.formInline.zlbh+"&status="
      +this.formInline.status+"&zfsj="+this.formInline.zfsj+"&start_time="+this.formInline.start_time+"&end_time="+this.formInline.end_time;
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.title = '退款详情'
      this.infoForm = row
      this.editFormVisible = true
    },
    //显示审核界面
    handleCheck: function(index, row){
        if(row.status != 1){
            this.$message({
                type: 'info',
                message: '该状态不能审核'
          })
          return false
        }
      this.title = '退款审核'
      this.checkForm = row
      this.checkForm.audit_opinion = ''
      this.checkForm.status = ''
      this.checkFormVisible = true
      console.log(this.checkForm)
    },
    // 编辑、增加页面保存方法
    submitForm(checkForm) {
      this.$refs[checkForm].validate(valid => {
        if (valid) {
          // 请求接口 
        wechatCheckRefund(this.checkForm)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.checkFormVisible = false
            this.getdata(this.formInline)
            this.$message({
                  type: 'success',
                  message: res.msg
                })
          } else {
            this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('系统错误!')
        })
        } else {
          return false
        }
      })
    },
    // 删除监控记录
    delMonitor(index, row) {
        this.$message({
          type: 'info',
          message: '暂不支持!'
        })
        return false;
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.checkFormVisible = false
      this.$refs[formName].resetFields()
    },
    // 根据不同值显示不同内容
    txcsTypeFormat(row,column){
        if(row.txcs > 0){
          return '已发送'
        }else{
          return '未发送'
        }
    },
    statusFormat(row,column){
      if(row.status == 1){
          return '待审核'
      }else if(row.status == 2){
          return '退款成功'
      }else if(row.status == 3){
          return '退款失败'
      }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/wechat/Refund.vue